module.exports = __webpack_public_path__ + "img/story.20faff4c.png";